// src/hooks/useQuizContext.js
import { useContext } from "react";
import { QuizContext } from "../context/quizReducer"; // <= point at reducer file

export const useQuizContext = () => {
  const context = useContext(QuizContext);

  if (!context) {
    throw Error('useQuizContext must be used inside a QuizContextProvider');
  }

  return context;
};
